import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  height: auto;
  border: 1px solid var(--border-soft);
  ${borderRadius.r2}
`;

export const Title = styled.div`
  ${typographyV2.titleMd};
  margin-bottom: 8px;
`;
